import React, { useContext } from "react";
import { ViewerFragment } from "../graphql/fragments";

export const ViewerContext = React.createContext<ViewerFragment | null>(null);

export default () => {
  return useContext(ViewerContext);
};
